import Tabby from 'tabbyjs';

export class TabManager {
  constructor() {
    // [data-tabs]が存在するなら
    if (document.querySelector('[data-tabs]')) {
      new Tabby('[data-tabs]');
    }
  }
}
